module.exports = require("dd-trace");